import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function ChatInputArea({ isStreaming, isDisabled, send, cancel }: Props) {
  const { t } = useTranslation();
  const [question, setQuestion] = React.useState("");
  const canSubmit = question.trim().length > 0 && !isDisabled && !isStreaming;

  function submit() {
    if (!canSubmit) return;
    send(question.trim());
    setQuestion("");
  }

  return (
    <div className={styles.chatInputArea}>
      <div
        className={styles.pill}
        onKeyDown={(event) => {
          if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            submit();
          }
        }}
      >
        <TextInput
          className={styles.input}
          isMultiline
          value={question}
          placeholder={t("chatbot.input.placeholder")}
          isDisabled={isDisabled}
          input={setQuestion}
        />
        <div className={styles.actions}>
          {isStreaming ? (
            <Button
              type="cancel"
              className={styles.submitButton}
              press={cancel}
            >
              {t("chatbot.input.cancel")}
            </Button>
          ) : (
            <Button
              type="submit"
              className={styles.submitButton}
              isDisabled={!canSubmit}
              press={submit}
            >
              {t("chatbot.input.send")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export { ChatInputArea };
